import React from 'react';
import { Icon } from './Icon.js';
export const IconGridCirclePlusFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M15.5,12h-1.75v-1.75c0-.414-.336-.75-.75-.75s-.75,.336-.75,.75v1.75h-1.75c-.414,0-.75,.336-.75,.75s.336,.75,.75,.75h1.75v1.75c0,.414,.336,.75,.75,.75s.75-.336,.75-.75v-1.75h1.75c.414,0,.75-.336,.75-.75s-.336-.75-.75-.75Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("circle", { cx: "5", cy: "5", r: "3.25", fill: "currentColor" }),
        React.createElement("circle", { cx: "13", cy: "5", r: "3.25", fill: "currentColor" }),
        React.createElement("circle", { cx: "5", cy: "13", r: "3.25", fill: "currentColor" })));
};
//# sourceMappingURL=IconGridCirclePlusFill18.js.map